import { computed, ref } from 'vue';
import { listLeadSources, saveLeadSource } from '@/api/settingsApi';
import { useSettingsEntityList } from './useSettingsEntityList';

export function useLeadSources() {
  const { afterMutation } = useSettingsEntityList();

  const loading = ref(false);
  const saving = ref(false);
  const error = ref(null);
  const items = ref([]);
  const searchQuery = ref('');

  const filteredItems = computed(() => {
    const q = searchQuery.value.trim().toLowerCase();
    if (!q) return items.value;
    return items.value.filter((row) => {
      const hay = [row.label, row.id].filter(Boolean).join(' ').toLowerCase();
      return hay.includes(q);
    });
  });

  const countLabel = computed(() => {
    const n = filteredItems.value.length;
    const total = items.value.length;
    if (searchQuery.value.trim() && n !== total) {
      return `${n} of ${total} sources`;
    }
    return `${total} source${total === 1 ? '' : 's'}`;
  });

  async function loadItems() {
    loading.value = true;
    error.value = null;
    try {
      const data = await listLeadSources({ includeInactive: true });
      items.value = Array.isArray(data?.items) ? data.items : [];
    } catch (e) {
      error.value = e?.message || 'Failed to load lead sources';
    } finally {
      loading.value = false;
    }
  }

  async function saveItem(payload) {
    saving.value = true;
    error.value = null;
    try {
      const data = await saveLeadSource(payload);
      await afterMutation(async () => {
        if (Array.isArray(data?.items)) {
          items.value = data.items;
        } else {
          await loadItems();
        }
      });
      return data?.item || null;
    } catch (e) {
      error.value = e?.message || 'Failed to save lead source';
      throw e;
    } finally {
      saving.value = false;
    }
  }

  return {
    loading,
    saving,
    error,
    items,
    searchQuery,
    filteredItems,
    countLabel,
    loadItems,
    saveItem
  };
}
